module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-all-card-26e4cefd32cc262abf23b421a9a3a42d.jpg";